import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json', // ← Changé : plus multipart
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Récupérer la dernière version
export const getLatestVersion = async () => {
  try {
    console.log('📡 Récupération dernière version...');
    const response = await axios.get(`${API_BASE_URL}/app/version/latest`, {
      headers: getHeaders()
    });
    console.log('✅ Dernière version récupérée:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Erreur récupération version:', error.response?.data || error.message);
    return null;
  }
};

// Publier une nouvelle version - SANS APK
export const publishVersion = async (versionData) => {
  try {
    console.log('📤 Publication nouvelle version (sans APK)...');
    console.log('📦 Données:', versionData);
    
    // Préparer le payload - SANS fichier
    const payload = {
      version_code: parseInt(versionData.version_code),
      version_name: versionData.version_name,
      force_update: versionData.force_update ? true : false,
      changelog: versionData.changelog || '',
      apk_url: versionData.apk_url || null // Optionnel, si vous avez une URL
    };
    
    const response = await axios.post(`${API_BASE_URL}/app/version`, payload, {
      headers: getHeaders()
    });
    
    console.log('✅ Version publiée avec succès:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Erreur publication version:', error.response?.data || error.message);
    throw error;
  }
};
  
// Supprimez prepareApk - Plus nécessaire